import { ofType } from 'redux-observable';
import { map } from 'rxjs';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import type { EpicWithThunk } from 'state/state.common';
import { getMailStatusMessage$ } from 'utils/streaming/messages';

export function mailSummaryFailedEpic(): EpicWithThunk {
  return (_action$, _state$, { streaming }) =>
    getMailStatusMessage$(streaming).pipe(
      ofType('MailSummaryFailed'),
      map(({ quoteId, orderId }) =>
        showNotificationThunk({
          level: 'warning',
          title: { id: 'secondaryMarket.errors.mailSummary.title' },
          content: [{ id: 'secondaryMarket.errors.mailSummary.message', values: { orderId: orderId ?? quoteId } }],
          closeAutomatically: true,
        }),
      ),
    );
}
